import React from 'react';

type AlertType = 'info' | 'warning' | 'danger' | 'success';

interface AlertBlockProps {
  type: AlertType;
  icon?: string;
  heading?: string;
  children?: React.ReactNode;
}

export function AlertBlock({ type, icon, heading, children }: AlertBlockProps) {
  return (
    <div className={`alert alert-${type} alert-block`}>
      {icon && <i className={`${icon} pull-left`} aria-hidden="true"></i>}
      {heading && <h4>{heading}</h4>}
      {children}
    </div>
  );
}
